import { render, staticRenderFns } from "./DetailPenarikan.vue?vue&type=template&id=1921ac75&scoped=true&"
import script from "./DetailPenarikan.vue?vue&type=script&lang=js&"
export * from "./DetailPenarikan.vue?vue&type=script&lang=js&"
import style0 from "./DetailPenarikan.vue?vue&type=style&index=0&id=1921ac75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921ac75",
  null
  
)

export default component.exports